import request from './axios';

/**
 * 获取管理团队成员
 * @returns {Promise<Object>} 返回团队成员列表
 */
export function getTeamMembers() {
  return request({
    url: '/webapi/team/members',
    method: 'get'
  });
} 